import { tv } from "@kirvanobr/theme";

export const styles = tv({
  slots: {
    base: "bg-transparent",
    header: "px-6",
    body: "px-6 py-4",
    footer: "px-6",
  },

  variants: {
    border: {
      true: {
        base: "bg-transparent border border-foreground-300",
      },
      false: {},
    },
  },
});
